import {plantNameFromParameter} from '../common/navigation'

import {usePlantParameter} from './usePlantParameter'

export const usePlantName = () => {
  const param = usePlantParameter()
  return plantNameFromParameter(param)
}
